/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { NbThemeService } from '@nebular/theme';
import { EMAIL_PATTERN } from '../constants';
import { InitUserService } from '../../init-user.service';
import { isEmpty, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserStore } from '../../user.store';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AppAlertService } from 'src/app/services/app-alert/app-alert.service';
import { environment } from 'src/environments/environment';
import { isString } from 'lodash';
@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NgxLoginComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  loginForm: FormGroup;
  alive: boolean = true;

  get email() { return this.loginForm?.get('email'); }
  get password() { return this.loginForm?.get('password'); }

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,
    protected router: Router,
    protected route: ActivatedRoute,
    protected initUserService: InitUserService,
    protected ngAuthService: NbAuthService,
    protected appAuthService: AuthService,
    private alertService: AppAlertService
  ) { }

  async ngOnInit() {

    this.initForm();

    const from: string = this.route.snapshot.queryParamMap.get("from");

    if (from == "email-verification") {
      this.alertService.showSuccessAlert("Email confirmed");
    }

    const code = this.route.snapshot.queryParamMap.get('id_token');
    if (code) {
      let googleAuthStatus = await this.appAuthService.exchangeGoogleCodeForToken(code);
      if (googleAuthStatus) {
        this.alertService.showSuccessAlert("Google authentication successful");
        this.initUser();
      }
    } else if (isString(code) && code.trim() !== '') {
      console.error('Authorization code not found');
      this.alertService.showErrorAlert('Authorization code not found');
    }

    let authenticated = await this.ngAuthService.isAuthenticated().toPromise()

    if (authenticated) {
      this.router.navigate(['/']);
    }

  }

  signInWithGoogle(): void {
    const strapiGoogleAuthUrl =  `${environment.API_BASE_URL}/connect/google`; // Replace with your Strapi Google auth URL
    window.location.href = strapiGoogleAuthUrl; // Redirect to the Google authentication endpoint
  }

  login(): void {
    // this.user = this.loginForm.value;
    // this.errors = [];
    // this.messages = [];
    // this.submitted = true;

    let email = this.loginForm.value.email;
    this.user = this.loginForm.value;
    this.user.identifier = email;
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.initUser();
      } else {
        this.errors = result.getErrors();
      }

      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

  initForm(){
    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && emailValidators.push(Validators.required);

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.loginForm = this.fb.group({
      email: this.fb.control('', [...emailValidators]),
      password: this.fb.control('', [...passwordValidators]),
      rememberMe: this.fb.control(false),
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  initUser() {
    this.initUserService.initCurrentUser()
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
